import { render } from "./archived-jobs.vue?vue&type=template&id=106647da"
import script from "./archived-jobs.vue?vue&type=script&lang=js"
export * from "./archived-jobs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__